<template>
    <v-dialog v-model="$store.state.showProfileDialogStatus" scrollable persistent :overlay="false" max-width="500px"
        transition="dialog-transition">
        <v-card color="surface">
            <FormC 
            :loading="loading"
            @submit="updateUserData"
            v-model="$store.state.user.entry"
            :form_elements="elements"
            :form="form"
            />
        </v-card>
    </v-dialog>
</template>

<script>
    import FormC from '@/components/form/form.vue';
    export default {
        components:{
            FormC,
        },
        name: "ProfileModal",
        data: () => ({
            loading:false,
            item:{},
            form:{
                title:'اطلاعات پروفایل',
                success_message:'سپاس گزاریم',
                description:'لطفا اطلاعات خود را با دقت وارد نمایید',
                form_review_primary_text:'ویرایش و ذخیره',
                form_submit_primary_text:'ثبت و ذخیره',
            },
        }),
        methods: {
            async updateUserData(data) {
                let entry = this.$store.state.info.elements
                    .map(e => `element_${e.element_id}`) // فقط کلیدها
                    .filter(key => key in data)           // فقط کلیدهایی که توی data هستن
                    .reduce((obj, key) => {
                    obj[key] = data[key];
                    return obj;
                    }, {});
                entry["id"] = data["id"];
                this.loading = true;
                try {
                    const response = await this.$api.post('/GuestForm/form/booking_update', {
                        form_id: this.$store.state.info.form_id,
                        data: entry,
                    }, { encrypt: true });
                    if (response.data.success) {
                        this.$store.state.showProfileDialogStatus = false;
                    }
                } catch (error) {
                    console.error(error);
                }
                this.loading = false;
            },
        },
        computed:{
            elements(){
                return this.$store.state.info.elements.filter(e=>'element_'+e.element_id !=this.$store.state.user.mobile_field);
            }
        }
        
    };
</script>

<style>
    /* hide number arrow */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>